module.exports = __webpack_public_path__ + "img/saum_steingrau_ohneral.df2c0d59.jpg";